<template>
  <roe-chart-table-switch
    name="Lead Indicators track saving behavior - Deferral Rate"
  >
    <template #chartView>
      <div class="table-row" v-for="year in lagIndicatorYears">
        <div class="table-unit table-desc-unit">
          {{ year }}
        </div>
        <div class="table-unit" v-for="(design, index) in designs">
          <roe-horizontal-bar
            :value="design.deferral_rate[year]"
            :color="designColorClasses[index]"
            :star="design.deferral_rate[year] > industryBenchmark.deferral_rate"
            :mark="industryBenchmark.deferral_rate"
          ></roe-horizontal-bar>
        </div>
      </div>
      <div class="table-description">
        <div class="table-description-unit">
          <span class="triangle"></span> Industry Median:
          {{ industryBenchmark.deferral_rate | percentage }}
        </div>
        <div class="table-description-unit">
          <span class="star"></span> Better than Industry Median
        </div>
      </div>
    </template>

    <template #tableView>
      <div class="table-row" v-for="year in lagIndicatorYears">
        <div class="table-unit table-desc-unit">
          {{ year }}
        </div>
        <div class="table-unit" v-for="design in designs">
          <span
            class="common-label"
            :class="{
              star: design.deferral_rate[year] > industryBenchmark.deferral_rate
            }"
          >
            {{ design.deferral_rate[year] | percentage }}</span
          >
        </div>
      </div>
      <div class="table-description">
        <div class="table-description-unit">
          <span class="triangle"></span> Industry Median:
          {{ industryBenchmark.deferral_rate | percentage }}
        </div>
        <div class="table-description-unit">
          <span class="star"></span> Better than Industry Median
        </div>
      </div>
    </template>
  </roe-chart-table-switch>
</template>

<script>
import RoeChartTableSwitch from "@/components/alternative-designs/_shared/ChartTableSwitch";
import { mapGetters } from "vuex";
import RoeHorizontalBar from "@/components/charts/HorizontalBar";

export default {
  name: "RoeDeferralRate",
  computed: {
    ...mapGetters([
      "designs",
      "lagIndicatorYears",
      "designColorClasses",
      "industryBenchmark"
    ])
  },
  components: {
    RoeHorizontalBar,
    RoeChartTableSwitch
  }
};
</script>
